import {Inject, Injectable} from '@angular/core';
import {DOCUMENT} from "@angular/common";

@Injectable({
  providedIn: 'root'
})
export class CookieService {

  private COOKIE_KEY = 'EuCookiePolicyMessage';
  public cookieAsked: boolean = false;

  constructor(@Inject(DOCUMENT) private document: any) {
  }

  enableCookie(){
    this.document.cookie = this.COOKIE_KEY + "=true;path=/;expires=Fri, 01 Jan 2100 00:00:00 GMT";
    this.cookieAsked = true;
  }

  putCookie(name, value) {
    this.document.cookie = name + "=" + value + ";path=/";
  }

  putCookieWithOptions(name, value, options) {
    this.document.cookie = name + "=" + value + options;
  }

  removeCookies() {
    let cookies: string[] = this.document.cookie.split(';');

    cookies.forEach((cookie) => {
      let keyvalue = cookie.split('=');
      this.document.cookie = keyvalue[0].trim() + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
    });
  }

  isCookieEnabled(){
    let cookies: string[];
    let result: { key: string; value: string } | undefined;
    let allcookies;

    cookies = this.document.cookie.split(';');
    allcookies = cookies.map((cookie) => {
      let keyvalue = cookie.split('=');

      return {
        key: keyvalue[0].trim(),
        value: keyvalue[1] ? keyvalue[1].trim():''
      }
    });
    result = allcookies.find((pair => pair.key === this.COOKIE_KEY));

    if(result) {
      this.cookieAsked = (result.value === 'true');
      return result.value === 'true';
    }
    return false;
  }
}
